export default "<m-cube\n    color=\"red\"\n    y=\"2\"\n></m-cube>\n";